import { PieChart } from '@mui/x-charts/PieChart';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

export const StatisticsSpentTimeCite = ({ item, title, subTitle }) => {
  const { t } = useTranslation();
  const [pieData, setPieData] = useState([]);

  useEffect(() => {
    if (item) {
      console.log(item);
      setPieData([
        {
          id: 0,
          value: item.item1.value,
          label: item.item1.label,
          color: item.item1.color,
          hours: item.item1.hours,
          percentage: item.item1.percentage,
        },
        {
          id: 1,
          value: item.item2.value,
          label: item.item2.label,
          color: item.item2.color,
          hours: item.item2.hours,
          percentage: item.item2.percentage,
        },
        {
          id: 2,
          value: item.item3.value,
          label: item.item3.label,
          color: item.item3.color,
          hours: item.item3.hours,
          percentage: item.item3.percentage,
        },
      ]);
    }
  }, [item]);

  return (
    <div className="statistics-spent-materials-block">
      <div className="statistics-spent-materials-block-top">
        <div className="statistics-spent-materials-text">
          <span className="statistics-spent-materials-count">
            {item?.totalCount} {t(title)}
          </span>
          <span className="statistics-spent-materials-count-text">{t(subTitle)}</span>
        </div>
      </div>
      <div className="statistics-time-wrap-row">
        <div className="statistics-time-info">
          {pieData.map(segment => (
            <div key={segment.id} className="time-interval">
              <span className="color" style={{ backgroundColor: segment.color }}></span>
              <span>{segment.label}</span>
              <span>
                {segment.value} {t('time-numb')}
              </span>
              <span>{segment.percentage}%</span>
              <div className="color-indicator" style={{ backgroundColor: segment.color }}></div>
            </div>
          ))}
        </div>
        <div className="pie-chart-wrap">
          <PieChart
            className="custom-pie-chart"
            series={[
              {
                data: pieData.map(({ id, value, color }) => ({
                  id,
                  value,
                  color,
                })),
              },
            ]}
            width={200}
            height={200}
          />
        </div>
      </div>
    </div>
  );
};
